import { useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as categoryApis from "../../utilities/apis/category"
import Layout from "../../components/Layout"

const Category = () => {
  const navigate = useNavigate()
  const { user, token } = useSelector(state => state.user)
  const nameRef = useRef(null)
  const params = new URLSearchParams(window.location.search)

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const name = nameRef.current.value
      const payload = { name }

      if (!params.has("id")) {
        const response = await categoryApis.createCategory(token, payload)
        if (!response.status) throw new Error(response.message)

        nameRef.current.value = ""
      } else {
        payload.id = parseInt(params.get("id"))
        const response = await categoryApis.updateCategory(token, payload)
        if (!response.status) throw new Error(response.message)
      }

      alert("Category saved")
    } catch (error) {
      alert(error.message)
    }
  }

  const getCategory = async () => {
    try {
      const response = await categoryApis.getCategory(token, params.get("id"))
      if (!response.status) throw new Error(response.message)

      nameRef.current.value = response.category.name
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (!user) navigate("/")

    if (params.has("id"))
      getCategory()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-5">
        <div className="w-75 mx-auto">
          <div className="row">
            <div className="col-4"></div>
            <div className="col-4">
              <div className="card text-dark">
                <div className="card-header bg-white border-bottom-0 text-center">
                  <h3 className="fw-bold m-0">Category</h3>
                </div>
                <div className="card-body">
                  <form method="POST" onSubmit={handleSubmit}>
                    <div className="form-floating mb-3">
                      <input ref={nameRef} type="text" className="form-control" id="name" placeholder="Name" required />
                      <label htmlFor="name">Name</label>
                    </div>
                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary py-3">Save</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-4"></div>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Category
